export const SCORE_OPTIONS = [1, 2, 3, 4, 5] as const;
export const SCORE_FILTER_OPTIONS = [0, ...SCORE_OPTIONS] as const;

export const scoreToStars = (score?: number | null): string => {
  if (!score || score < 1 || score > 5) {
    return "-";
  }
  return `${"★".repeat(score)}${"☆".repeat(5 - score)}`;
};

export const scoreFilterLabel = (score: number): string => {
  if (score === 0) {
    return "未設定";
  }
  return scoreToStars(score);
};
